module.exports = __webpack_public_path__ + "img/148.401edd48.jpg";